<template>
  <div class="text-end">
    <div class="line-cart line-cart-10">
      <LineChart
        :chartData="modelValue.avgByDays"
        :options="modelValue.optionsNoText"
        :key="key"
      />
    </div>
    <div class="text-area right">
      <h2 class="bold-19 text-green mb-2">
        {{ $t("home.avgBasket") }}
      </h2>
      <h2 class="bold-19 text-green">
        <EditOnClick
          :model-value="modelValue?.total?.success?.avg"
          type="price"
          :padding="false"
          :editable="false"
        />
      </h2>
    </div>
  </div>
</template>
<script>
import EditOnClick from "../inputs/EditOnClick.vue";
import { LineChart } from "vue-chart-3";

export default {
  name: "AvgBasket",
  components: { LineChart, EditOnClick },
  props: {
    key: Number,
    modelValue: Object,
  },
  data() {},
};
</script>
